/**
 * DEPRECATED — the legacy emailed-link family.
 *
 * These four states exist to keep links from before the current `/view` routes working. The
 * three `customer*` states below take a legacy proposal id, resolve it to a modern
 * consultation and redirect into `view.consultation`, `view.proposal` or `view.accepted`;
 * `ViewLegacyState` is the notice they fall back to when that lookup fails.
 *
 * Still live, so it must keep working — but no new work should land here:
 * - it will not get a `presentation_v2` sibling. The flag cannot be resolved on
 *   `ViewLegacyState`: it declares no params, so `getFlagsPublic` (which requires
 *   serviceProviderId, consultationId and customerToken) has nothing to send, and it is not
 *   in `states-public.constant.js`, so `getPresentationFlags` would route it to
 *   `getFlagsPrivate`, which rejects without a session. The three redirect states need no v2
 *   of their own, since their destinations are already flag-gated
 * - the notice copy names a placeholder provider, see `view-legacy-page.cmp.js`
 *
 * Retire the whole family once legacy links are out of circulation: delete these states, the
 * `legacyUnavailable` component, and the `customerdetails`/`customeraccepted` entries in
 * `states-public.constant.js`.
 *
 * @deprecated superseded by the `view.*` states; kept only for links already in the wild
 */
export const ViewLegacyState = {
	url: '/unavailable',
	title: 'Consultation Legacy Data',
	template: '<legacy-unavailable></legacy-unavailable>',
	lazyLoad: $transition$ => {
		const $ocLazyLoad = $transition$.injector().get('$ocLazyLoad');
		const $log = $transition$.injector().get('$log');
		return import(
			/* webpackChunkName: "viewLegacyPageMod" */
			'@Containers/view-legacy-page/view-legacy-page.cmp.js'
		)
			.then(res => $ocLazyLoad.load({name: res.default}))
			.catch(err => $log.error(err));
	},
};
//
/**
 * @deprecated legacy emailed comparison link; redirects into `view.consultation`
 *
 * Note this state is absent from `states-public.constant.js` while its two siblings
 * `customerdetails` and `customeraccepted` are listed, so anything asking
 * `NavSvc.isStatePublic` treats this one as private. It redirects before rendering, so
 * nothing depends on that today.
 */
export const ViewLegacyCustomerSummaryState = {
	url: '/customersummary/:proposalId/:serviceProviderId/:customerToken',
	title: 'Consultation Comparison',
	params: {proposalId: null, serviceProviderId: null, customerToken: null},
	resolve: [
		{
			token: 'legacyData',
			policy: {when: 'LAZY'},
			deps: ['ConsultationService', '$log', '$transition$'],
			resolveFn: (ConsultationSvc, $log, trans) =>
				ConsultationSvc.getConsultationFromLegacyPresentedProposal({
					proposalId: trans.params().proposalId,
					serviceProviderId: trans.params().serviceProviderId,
					customerToken: trans.params().customerToken,
				})
					.then(resObj => {
						if (resObj.data?.success) {
							trans.router.stateService.go('view.consultation', {
								customerToken: trans.params().customerToken,
								serviceProviderId: trans.params().serviceProviderId,
								consultationId: resObj.data.payLoad.consultation_id,
							});
						}
					})
					.catch(resObj => {
						$log.error(resObj.data.error);
						trans.router.stateService.go('view.legacy');
					}),
		},
	],
};
//
/** @deprecated legacy emailed proposal link; redirects into `view.proposal` */
export const ViewLegacyCustomerDetailsState = {
	url: '/customerdetails/:proposalId/:serviceProviderId/:customerToken/:position',
	title: 'Proposal Details',
	params: {proposalId: null, serviceProviderId: null, customerToken: null, position: null},
	resolve: [
		{
			token: 'legacyData',
			policy: {when: 'LAZY'},
			deps: ['ConsultationService', '$log', '$transition$'],
			resolveFn: (ConsultationSvc, $log, trans) =>
				ConsultationSvc.getConsultationFromLegacyPresentedProposalWithPosition({
					proposalId: trans.params().proposalId,
					serviceProviderId: trans.params().serviceProviderId,
					customerToken: trans.params().customerToken,
					proposalPosition: trans.params().position,
				})
					.then(resObj => {
						if (resObj.data?.success) {
							trans.router.stateService.go('view.proposal', {
								customerToken: trans.params().customerToken,
								serviceProviderId: trans.params().serviceProviderId,
								consultationId: resObj.data.payLoad.consultation_id,
								proposalId: resObj.data.payLoad.proposal_id,
							});
						}
					})
					.catch(resObj => {
						$log.error(resObj.data.error);
						trans.router.stateService.go('view.legacy');
					}),
		},
	],
};
//
/** @deprecated legacy emailed accepted-proposal link; redirects into `view.accepted` */
export const ViewLegacyCustomerAcceptedState = {
	url: '/accepted/:proposalId/:serviceProviderId/:customerToken',
	title: 'Accepted Proposal',
	params: {proposalId: null, serviceProviderId: null, customerToken: null},
	resolve: [
		{
			token: 'legacyData',
			policy: {when: 'LAZY'},
			deps: ['ConsultationService', '$log', '$transition$'],
			resolveFn: (ConsultationSvc, $log, trans) =>
				ConsultationSvc.getConsultationFromLegacyAcceptedProposal({
					proposalId: trans.params().proposalId,
					serviceProviderId: trans.params().serviceProviderId,
					customerToken: trans.params().customerToken,
				})
					.then(resObj => {
						if (resObj.data?.success) {
							trans.router.stateService.go('view.accepted', {
								customerToken: trans.params().customerToken,
								serviceProviderId: trans.params().serviceProviderId,
								consultationId: resObj.data.payLoad.consultation_id,
								proposalId: resObj.data.payLoad.proposal_id,
							});
						}
					})
					.catch(resObj => {
						$log.error(resObj.data.error);
						trans.router.stateService.go('view.legacy');
					}),
		},
	],
};
